import { ErrorReload } from 'modules/common/components/ErrorReload/ErrorReload'
import { Link } from 'modules/common/components/Link/Link'
import { useTranslation } from 'modules/common/hooks/useTranslation'
import { useCorporateSponsorship } from 'modules/corporate/hooks/useCorporateSponsorship'
import { Trans } from 'react-i18next'
import { SponsorshipContainerSkeleton } from './SponsorshipContainerSkeleton'
import { SponsorshipFaqContainer } from './SponsorshipFaqContainer/SponsorshipFaqContainer'
import { SponsorshipOfferContainer } from './SponsorshipOfferContainer/SponsorshipOfferContainer'
import { SponsorshipProcessContainer } from './SponsorshipProcessContainer/SponsorshipProcessContainer'

export const SponsorshipContainer = () => {
  const { t } = useTranslation('settings-components')

  const {
    activeVoucher,
    isCorporateSponsorshipLoading,
    isCorporateSponsorshipError,
    refetchCorporateSponsorship,
    isEligibleForSponsorship,
  } = useCorporateSponsorship()

  if (isCorporateSponsorshipLoading) {
    return <SponsorshipContainerSkeleton />
  }

  if (isCorporateSponsorshipError) {
    return <ErrorReload onReload={refetchCorporateSponsorship} />
  }

  if (!isEligibleForSponsorship || !activeVoucher) {
    return null
  }

  return (
    <div className="w-full max-w-[952px] space-y-12 p-12 text-center">
      <div className="space-y-4">
        <h1>{t('sponsorshipContainer.title')}</h1>
        <h2>{t('sponsorshipContainer.subtitle')}</h2>
      </div>
      <SponsorshipOfferContainer sponsorshipVoucher={activeVoucher} />
      <SponsorshipProcessContainer />
      <SponsorshipFaqContainer />
      <Trans
        parent="p"
        className="text-info-400"
        components={{
          linkComponent: (
            <Link href={activeVoucher.conditionsLink} className="underline" />
          ),
        }}
      >
        {t('sponsorshipContainer.conditions')}
      </Trans>
    </div>
  )
}
